import React from "react";
import { Nav } from "@/components/landing/Nav";
import { Footer } from "@/components/landing/Footer";
import { Stats } from "@/components/landing/Stats";
import { RevealHeading } from "@/components/landing/Motion";
import { ScribbleCircle, Blob, Sparkle, BnGlyph } from "@/components/landing/Decorations";

export default function AboutPage() {
    return (
        <div className="paper-grain min-h-screen">
            <Nav/>
            <main className="pt-32 pb-24 relative overflow-hidden">
                <Blob color="#FF4FA3" className="absolute top-32 -right-20 w-72 h-72 opacity-30 animate-float-slow"/>
                <ScribbleCircle color="#FFD23F" className="absolute bottom-32 left-[5%] w-32 h-32 opacity-40 animate-float-fast"/>
                <BnGlyph glyph="আমরা" className="absolute -right-2 bottom-32 text-[160px] lg:text-[240px] leading-none font-bold opacity-[0.04] select-none" color="#0A0A0A"/>

                <div className="mx-auto max-w-[1100px] px-5 sm:px-8 relative">
                    <p className="text-[11px] uppercase tracking-[0.22em] font-semibold text-coral mb-5">About</p>
                    <RevealHeading as="h1" className="h-display text-[48px] sm:text-[72px] lg:text-[112px] text-ink leading-[0.95]">
                        We're building the <span className="italic-display text-coral">listening half</span> of the Bengali web.
                    </RevealHeading>

                    <div className="mt-12 max-w-[680px] space-y-6 text-[17px] text-ink-muted leading-[1.7]">
                        <p>
                            300 million people speak Bengali. Yet the internet is almost entirely written — leaving millions behind. Audo bridges that gap by turning Bengali articles into natural, high-quality audio in seconds.
                        </p>
                        <p>
                            We built Audo for Bangladeshi newsrooms, portals, and content creators who want to reach a wider audience without the complexity or cost of traditional audio production. One line of embed code is all it takes to bring your content to life.
                        </p>
                        <p>
                            Our platform is designed around two core beliefs: Bengali pronunciation should sound <span className="italic-display text-ink">natural</span> to Bengali speakers, and pricing should make sense for the Bangladeshi market — in BDT, not dollars.
                        </p>
                        <p>
                            From free tools for independent bloggers to enterprise solutions for national media networks, Audo scales with your audience.
                        </p>
                    </div>

                    <Sparkle color="#FF5B3E" className="my-16 w-9 h-9 mx-auto animate-float-slow"/>

                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-4">
                        {[
                            { label: "Bengali-first", desc: "Every voice, every model, every feature is optimised for the Bengali language and its speakers." },
                            { label: "BDT pricing", desc: "No surprise USD invoices. Plans start free and scale affordably for Bangladeshi margins." },
                            { label: "One embed, anywhere", desc: "Drop a single script tag into any CMS or website and your audio player appears instantly." },
                        ].map((item, i) => (
                            <div key={i} className="bg-white rounded-3xl p-6 border border-cream-300 shadow-soft">
                                <h3 className="font-display text-[22px] font-semibold tracking-tight text-ink mb-3">{item.label}</h3>
                                <p className="text-[14px] text-ink-muted leading-relaxed">{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="mt-20">
                    <Stats/>
                </div>
            </main>
            <Footer/>
        </div>
    );
}
